<template>
  <div class="prizes-page prizes-stacked-layout">
    <!-- What You Could Win Section -->
    <section class="what-you-win-section py-5">
      <div class="container">
        <h2 class="section-title text-center mb-5" v-html="$t('Prizes.SectionTitle')">
        </h2>
        
        <div class="row g-4 justify-content-center">
          <!-- Card 1 -->
          <div class="col-lg-4 col-md-6 col-12">
            <div class="prize-card">
              <div class="prize-image-container">
                <img src="https://snippcheck.blob.core.windows.net/files/OffersDemoCampaign/headfhonebadge.png" :alt="$t('Prizes.WinHeadphones')" class="img-fluid w-100" />
              </div>
              <div class="prize-card-body">
                <h3 class="prize-card-title">{{ $t('Prizes.WinHeadphones') }}</h3>
                <p class="prize-card-desc">
                  {{ $t('Prizes.HeadphonesDesc') }}
                </p>
              </div>
            </div>
          </div>
          
          <!-- Card 2 -->
          <div class="col-lg-4 col-md-6 col-12">
            <div class="prize-card">
              <div class="prize-image-container">
                <img src="https://snippcheck.blob.core.windows.net/files/OffersDemoCampaign/plane-badge.png" :alt="$t('Prizes.WinTravel')" class="img-fluid w-100" />
              </div>
              <div class="prize-card-body">
                <h3 class="prize-card-title">{{ $t('Prizes.WinTravel') }}</h3>
                <p class="prize-card-desc">
                  {{ $t('Prizes.TravelDesc') }}
                </p>
              </div>
            </div>
          </div>
          
          <!-- Card 3 -->
          <div class="col-lg-4 col-md-6 col-12">
            <div class="prize-card">
              <div class="prize-image-container">
                <img src="https://snippcheck.blob.core.windows.net/files/OffersDemoCampaign/accessories-badge.png" :alt="$t('Prizes.WinAccessories')" class="img-fluid w-100" />
              </div>
              <div class="prize-card-body">
                <h3 class="prize-card-title">{{ $t('Prizes.WinAccessories') }}</h3>
                <p class="prize-card-desc">
                  {{ $t('Prizes.AccessoriesDesc') }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- More Prizes Section -->
    <section class="more-prizes-section py-5 bg-light-section">
      <div class="container">
        <h2 class="section-title-left mb-4">{{ $t('Prizes.MorePrizes') }}</h2>
        
        <!-- Tab Navigation Buttons -->
        <div class="tab-buttons-container mb-4">
          <button 
            class="tab-btn" 
            :class="{ active: activeTab === 'grand' }" 
            @click="activeTab = 'grand'"
          >
            {{ $t('Prizes.GrandPrizes') }}
          </button>
          <button 
            class="tab-btn" 
            :class="{ active: activeTab === 'secondary' }" 
            @click="activeTab = 'secondary'"
          >
            {{ $t('Prizes.SecondaryPrizes') }}
          </button>
        </div>
        
        <!-- Tab Content Grid -->
        <div class="row g-4">
          <div 
            class="col-lg-6 col-12" 
            v-for="(prize, index) in filteredMorePrizes" 
            :key="index"
          >
            <div class="more-prize-card d-flex align-items-center">
              <div class="more-prize-img-wrapper">
                <img :src="prize.image" :alt="$t(prize.titleKey)" class="img-fluid" />
              </div>
              <div class="more-prize-info">
                <span class="badge-new">{{ $t('Prizes.New') }}</span>
                <h4 class="more-prize-title">{{ $t(prize.titleKey) }}</h4>
                <p class="more-prize-desc">{{ $t(prize.descKey) }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

  
  </div>
</template>

<script>
export default {
  name: 'PrizesStacked',
  data() {
    return {
      activeTab: 'grand',
      morePrizes: {
        grand: [
          {
            image: '/assets/images/headfhone-icon.png',
            titleKey: 'Prizes.WinHeadphones',
            descKey: 'Prizes.HeadphonesShortDesc'
          },
          {
            image: '/assets/images/headfhone-icon.png',
            titleKey: 'Prizes.WinHeadphones',
            descKey: 'Prizes.HeadphonesShortDesc'
          },
          {
            image: '/assets/images/headfhone-icon.png',
            titleKey: 'Prizes.WinHeadphones',
            descKey: 'Prizes.HeadphonesShortDesc'
          }
        ],
        secondary: [
          {
            image: '/assets/images/plane1.png',
            titleKey: 'Prizes.WinTravel',
            descKey: 'Prizes.TravelShortDesc'
          },
          {
            image: '/assets/images/accessories1.png',
            titleKey: 'Prizes.WinAccessories',
            descKey: 'Prizes.AccessoriesShortDesc'
          },
          {
            image: '/assets/images/plane1.png',
            titleKey: 'Prizes.WinTravel',
            descKey: 'Prizes.TravelShortDesc'
          }
        ]
      }
    };
  },
  computed: {
    filteredMorePrizes() {
      return this.morePrizes[this.activeTab];
    }
  }
};
</script>

<style scoped>
/* Prizes Stacked Layout styling */
.prizes-page {
  font-family: 'Roboto', sans-serif;
  background-color: #ffffff;
}

/* What You Could Win Section */
.section-title {
  font-size: 2.25rem;
  font-weight: 700;
  color: #333333;
}

.text-blue {
  color: #2584C5;
}

.prize-card {
  background-color: #ffffff;
  border-radius: 16px;
  overflow: hidden;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  height: 100%;
}

.prize-card:hover {
  transform: translateY(-5px);
}

.prize-image-container {
  overflow: hidden;
  border-radius: 16px;
}

.prize-image-container img {
  border-radius: 16px;
  transition: transform 0.5s ease;
}

.prize-card:hover .prize-image-container img {
  transform: scale(1.03);
}

.prize-card-body {
  padding: 1.5rem 0.5rem;
  text-align: left;
}

.prize-card-title {
  font-size: 1.35rem;
  font-weight: 700;
  color: #000000;
  margin-bottom: 0.75rem;
}

.prize-card-desc {
  font-size: 0.95rem;
  line-height: 1.5;
  color: #555555;
  margin-bottom: 0;
}

/* More Prizes Section */
.bg-light-section {
  background-color: #f8fafc;
}

.section-title-left {
  font-size: 2rem;
  font-weight: 700;
  color: #333333;
}

/* Tab buttons */
.tab-buttons-container {
  display: flex;
  gap: 12px;
}

.tab-btn {
  background-color: #ffffff;
  color: #717d96;
  border: 1px solid #cbd5e1;
  font-size: 0.95rem;
  font-weight: 600;
  padding: 0.6rem 1.75rem;
  border-radius: 50px;
  cursor: pointer;
  transition: all 0.3s ease;
  outline: none;
}

.tab-btn:hover {
  color: #2584C5;
  border-color: #2584C5;
}

.tab-btn.active {
  background-color: #2584C5;
  color: #ffffff;
  border-color: #2584C5;
  box-shadow: 0 4px 12px rgba(37, 132, 197, 0.2);
}

/* More prize cards */
.more-prize-card {
  background-color: #ffffff;
  border: 1px solid #eaeef2;
  border-radius: 16px;
  padding: 1.25rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.01);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  height: 100%;
}

.more-prize-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.05);
}

.more-prize-img-wrapper {
  background-color: #2584C5;
  border-radius: 12px;
  width: 90px;
  height: 90px;
  min-width: 90px;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  padding: 8px;
}

.more-prize-img-wrapper img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  filter: drop-shadow(0 4px 6px rgba(0, 0, 0, 0.1));
}

.more-prize-info {
  margin-left: 1.25rem;
  text-align: left;
}

.badge-new {
  display: inline-block;
  background-color: #5ea7db;
  color: #ffffff;
  font-size: 0.75rem;
  font-weight: 700;
  text-transform: uppercase;
  padding: 0.15rem 0.5rem;
  border-radius: 4px;
  margin-bottom: 0.4rem;
  letter-spacing: 0.5px;
}

.more-prize-title {
  font-size: 1.15rem;
  font-weight: 700;
  color: #000000;
  margin-bottom: 0.25rem;
}

.more-prize-desc {
  font-size: 0.85rem;
  color: #555555;
  line-height: 1.4;
  margin-bottom: 0;
}

/* FPO Terms */
.fpo-terms-text {
  font-size: 0.8rem;
  line-height: 1.6;
  color: #666666;
  max-width: 900px;
}

/* Responsive Overrides */
@media (max-width: 991px) {
  .section-title {
    font-size: 1.85rem;
  }
  .section-title-left {
    font-size: 1.65rem;
  }
}

@media (max-width: 767px) {
  .prize-card-body {
    padding: 1rem 0.25rem;
  }
  .prize-card-title {
    font-size: 1.2rem;
  }
  .tab-btn {
    padding: 0.5rem 1.25rem;
    font-size: 0.85rem;
  }
  .more-prize-card {
    padding: 1rem;
  }
  .more-prize-img-wrapper {
    width: 80px;
    height: 80px;
    min-width: 80px;
  }
  .more-prize-info {
    margin-left: 1rem;
  }
}
</style>

